import { render } from "./IconChevronRightDouble.vue?vue&type=template&id=0cf1a041"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronRightDouble.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cf1a041"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cf1a041', __exports__)) {
    api.reload('0cf1a041', __exports__)
  }
  
  module.hot.accept("./IconChevronRightDouble.vue?vue&type=template&id=0cf1a041", () => {
    api.rerender('0cf1a041', render)
  })

}


export default __exports__